export const MAIN_SEARCH_HOTEL_TEST_IDS = {
  // ─── Hotel Search Form ───
  formContainer: 'main-search-hotel-form-container',
  title: 'main-search-hotel-title',

  // ─── Form Fields ───
  destinationSelect: 'main-search-hotel-destination-select',
  checkInDate: 'main-search-hotel-checkin-date',
  checkOutDate: 'main-search-hotel-checkout-date',
  roomsSelect: 'main-search-hotel-rooms-select',
  guestsSelect: 'main-search-hotel-guests-select',

  // ─── Actions ───
  searchButton: 'main-search-hotel-search-btn',
  managedByLabel: 'main-search-hotel-managed-by-label',
  managedByIcon: 'main-search-hotel-managed-by-icon',
} as const;
